import "./styles.css";
import { Layout, Space, Row, Col } from "antd";
import { HomeCadastro } from "../../components/homeCadastro";
import { HomeFormacao } from "../../components/homeFormacao";
import { HomeExperiencias } from "../../components/homeExperiencias";
import { HomeVagas } from "../../components/homeVagas";
import React from "react";

const styles = {
  row: {
    flexGrow: 1,
    padding: "1%",
  },
};

const Home = () => {
  return (
    <Layout.Content>
      <Row align="middle" justify="center" style={styles?.row}>
        <Col xs={24} sm={24} md={20} lg={14} xl={14} xxl={10} align="left">
          <Space direction="vertical" className="full-width" size={30}>
            <HomeCadastro />
            <HomeFormacao />
            <HomeExperiencias />
            <HomeVagas />
          </Space>
        </Col>
      </Row>
    </Layout.Content>
  );
};

export default Home;
